import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../utils/ui/classes';
import CheckCircleIcon from '../v2/icons/CircleCheckIcon';
import SolidCircleXIcon from '../v2/icons/SolidCircleXIcon';
import InfoIcon from '../v2/icons/InfoIcon';
import XIcon from '../v2/icons/XIcon';
import ExclamationIcon from '../v2/icons/ExclamationIcon';

const closeButtonBaseCss =
  'inline-flex rounded-md p-1.5 focus:outline-none focus-ring-2 focus:ring-offset-2';

function getIcon(type) {
  switch (type) {
    case 'warning':
      return <ExclamationIcon className="w-5 h-5 text-yellow-400" />;
    case 'error':
      return <SolidCircleXIcon className="w-5 h-5 text-red-400" />;
    case 'success':
      return <CheckCircleIcon className="w-5 h-5 text-green-400" />;
    case 'general':
      return;
    default:
      return <InfoIcon className="w-5 h-5 text-blue-400" />;
  }
}

const titleBaseClasses = ['text-sm', 'font-medium', 'mb-2'];

function getCloseButtonClassName(type) {
  let colorClassName;
  switch (type) {
    case 'warning':
      colorClassName =
        'text-yellow-500 hover:bg-yellow-100 focus:ring-offset-yellow-50 focus:ring-yellow-600';
      break;
    case 'error':
      colorClassName =
        'text-red-500 hover:bg-red-100 focus:ring-offset-red-50 focus:ring-red-600';
      break;
    case 'success':
      colorClassName =
        'text-green-500 hover:bg-green-100 focus:ring-offset-green-50 focus:ring-green-600';
      break;
    case 'general':
      colorClassName = 'text-white-800';
      break;
    default:
      colorClassName =
        'text-blue-500 hover:bg-blue-100 focus:ring-offset-blue-50 focus:ring-blue-600';
  }

  return getClassName(closeButtonBaseCss, colorClassName);
}

function getTitleClassName(type) {
  let colorClassName;
  switch (type) {
    case 'warning':
      colorClassName = 'text-yellow-800';
      break;
    case 'error':
      colorClassName = 'text-red-800';
      break;
    case 'success':
      colorClassName = 'text-green-800';
      break;
    case 'general':
      colorClassName = 'text-white-800';
      break;
    default:
      colorClassName = 'text-blue-800';
  }

  return getClassName(titleBaseClasses, colorClassName);
}

const textBaseClasses = ['text-sm'];
function getTextClassName(type) {
  let colorClassName;
  switch (type) {
    case 'warning':
      colorClassName = 'text-yellow-700';
      break;
    case 'error':
      colorClassName = 'text-red-700';
      break;
    case 'success':
      colorClassName = 'text-green-700';
      break;
    case 'general':
      colorClassName = 'text-white-700';
      break;
    default:
      colorClassName = 'text-blue-700';
  }

  return getClassName(textBaseClasses, colorClassName);
}

const defaultClassName = ['p-4', 'rounded-md'];

function getAlertClassName(type, className) {
  let colorClassName;
  switch (type) {
    case 'warning':
      colorClassName = 'bg-yellow-50';
      break;
    case 'error':
      colorClassName = 'bg-red-50';
      break;
    case 'success':
      colorClassName = 'bg-green-50';
      break;
    case 'general':
      colorClassName = 'bg-yellow-50';
      break;
    default:
      colorClassName = 'bg-blue-50';
  }
  if (type === 'general') {
    const defaultNames = ['p-1', ''];
    return getClassName(colorClassName, defaultNames, className);
  }
  return getClassName(colorClassName, defaultClassName, className);
}
export default class Alert extends Component {
  renderCloseButton(type) {
    const { canClose, onClose, dataTestId = '' } = this.props;

    if (!canClose && !onClose) {
      return null;
    }

    return (
      (<div data-testid={dataTestId} className="ml-auto pl-3">
        <div data-testid="div-152a1455" className="-mx-1.5 -my-1.5">
          <button
            data-testid="button-f04a07e6"
            className={getCloseButtonClassName(type)}
            type="button"
            onClick={onClose}>
            <XIcon className="w-5 h-5" />
          </button>
        </div>
      </div>)
    );
  }

  render() {
    const { title, children, type, className, dataTestId } = this.props;
    return (
      (<div
        data-testid={dataTestId}
        className={getAlertClassName(type, className)}
        role="alert">
        <div data-testid="div-e687a378" className="relative">
          <div data-testid="div-d944188f" className="flex">
            <div data-testid="div-b0d3acbe" className="flex-shrink-0">{getIcon(type)}</div>
            <div data-testid="div-8d9aa666" className="mx-3 flex-1">
              {title && <p data-testid="p-b49e11e1" className={getTitleClassName(type)}>{title}</p>}

              <div data-testid="div-a59b7e5d" className={getTextClassName(type)}>{children}</div>
            </div>
            {this.renderCloseButton(type)}
          </div>
        </div>
      </div>)
    );
  }
}

Alert.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  title: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.any,
  canClose: PropTypes.bool,
  onClose: PropTypes.func,
};

Alert.defaultProps = {
  canClose: false,
};
